
window.initLemtoshLab = function () {
  const container = document.querySelector('.the_lab_sections');
  if (!container) return; // Exit if the section is not present

  // console.log('Lemtosh Lab Script Initialized');

  // === Equal Height  ===
  function setEqualHeight() {
    if (window.innerWidth <= 999) {
      if (window.setGridHeight) {
        window.setGridHeight('.lemtoshlab_sections .info_heading');
        window.setGridHeight('.lemtoshlab_sections .info_content');
      }
    } else {
      document.querySelectorAll('.lemtoshlab_sections .info_content').forEach(h => {
        h.style.minHeight = 'auto';
      })
    }
  }

  // Run once on init
  setTimeout(setEqualHeight, 1000);

  // Avoid duplicate listeners if possible, though rigorous deduplication might require more state
  // ideally window.setGridHeight is idempotent
  window.removeEventListener('resize', setEqualHeight); 
  window.addEventListener('resize', setEqualHeight);


  // === Close Button ===
  const closeButton = document.querySelector('.js-lab-close-button');
  if (closeButton) {
    // specific valid logic to remove old listeners is harder without named functions
    // but cloning the node removes listeners if we wanted to be super clean. 
    // For now, we assume re-init happens on new DOM, so old listeners are gone with old DOM.
    closeButton.addEventListener('click', function () {
      document.referrer ? window.history.back() : window.location.href = '/'
    });
  }

  // Utility function to update tabindex for elements
  function updateTabIndex() {
    const allSections = document.querySelectorAll('section');
    allSections.forEach(section => {
      const isActive = section.classList.contains('active');
      const focusableElements = section.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]'
      );

      focusableElements.forEach(element => {
        element.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    });
  }

  // === Update tabindex on initial load ===
  updateTabIndex();

  // ===  Next | Previus Button ===
  const nextButtons = document.querySelectorAll('.js-action-button');
  nextButtons.forEach(button => {
    button.addEventListener('click', function () {
      const targetSection = document.querySelector(`.${this.getAttribute('data-section')}`);
      if(targetSection) targetSection.classList.add('active');
      
      const currentSection = this.closest("section");
      if(currentSection) currentSection.classList.remove('active');

      updateTabIndex();
      if (this.dataset.section == "lemtoshLab_frame") {
        const breadcrumb = document.querySelector('div.breadcrumb');
        if(breadcrumb) breadcrumb.classList.remove('hidden');
      } else if (this.dataset.section == "lemtoshLab_banner") {
        const breadcrumb = document.querySelector('div.breadcrumb');
        if(breadcrumb) breadcrumb.classList.add('hidden');
      }
      if (this.dataset.moveTo == "tintSection") {
        tintSection.initSliders();
      }
    });
    if (button.classList.contains('arrow-animate')) {
      button.addEventListener('animationend', () => {
        button.classList.remove('animate')
      });
    }
  });

  // === Tint Product Json ===
  const tintProductsJsonEl = document.getElementById('tint_products_json');
  if (!tintProductsJsonEl) return;
  
  let tint_products_json = JSON.parse(tintProductsJsonEl.innerHTML);
  let activeProduct = null;

  // console.log(tint_products_json);

  let frameSection = {
    init: function () {
      this.frameImage = document.querySelector('#slider-frames');
      this.frameVariant = document.querySelector('#variants-frames');
      this.frameValue = document.querySelectorAll('frame-value');
      this.buttonNext = document.querySelector('.lemtoshLab_frame .button--next');
      this.variants = document.querySelectorAll('[data-product]');
      
      if (!this.frameImage) return;

      this.slider = new KeenSlider(this.frameImage, {
        loop: true,
        breakpoints: {
          "(max-width: 999px)": {
            slides: { perView: 1, spacing: 0 },
            defaultAnimation: { duration: 500 },
            detailsChanged: (s) => { s.slides.forEach((element, idx) => { element.style.opacity = s.track.details.slides[idx].portion, element.querySelector('img').style.transform = 'none' }) },
            renderMode: "custom",
          },
          "(min-width: 1000px)": {
            slides: { origin: "center", perView: 1.8, spacing: 0 },
            defaultAnimation: { duration: 1000 },
            detailsChanged: (s) => { s.slides.forEach((element, idx) => { element.querySelector('img').style.transform = `scale(max(${s.track.details.slides[idx].portion},0.7))`, element.style.opacity = 1 }) }
          }
        },
        created: (slider) => {
          this._triggerButtons(slider);
          const activeBtn = this.frameVariant.querySelector('.variant-button.active');
          if(activeBtn) activeBtn.click();
        },
        slideChanged: (slider) => {
          this._changeButtons(slider);
          if(this.buttonNext) this.buttonNext.classList.add('animate');
        }
      });
    },
    _triggerButtons: function (slider) {
      const buttons = this.frameVariant.querySelectorAll('[data-slide-to]');
      //const sizes = sizeVariant.querySelectorAll('[data-product]');
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const slideTo = parseInt(button.getAttribute('data-slide-to'));
          slider.moveToIdx(slideTo);
          this._optionVariants(button.dataset.productId, button.dataset.frameValue);
        })
      });
      slider.slides.forEach(slide => {
        slide.addEventListener('click', () => {
          slider.moveToIdx(parseInt(slide.dataset.slide));
        });
      });
    },
    _changeButtons: function (slider) {
      const buttons = this.frameVariant.querySelectorAll('[data-slide-to]');
      const activeSlideIndex = slider.track.details.rel;

      buttons.forEach(button => {
        button.classList.remove('active');
        // button.setAttribute('aria-selected', 'false');
        button.setAttribute('aria-checked', 'false');
      });

      if (buttons[activeSlideIndex]) {
        buttons[activeSlideIndex].classList.add('active');
        // buttons[activeSlideIndex].setAttribute('aria-selected', 'true');
        buttons[activeSlideIndex].setAttribute('aria-checked', 'true');
        this._optionVariants(buttons[activeSlideIndex].dataset.productId, buttons[activeSlideIndex].dataset.frameValue);
      }
    },
    _optionVariants: function (productID, productFrame) {
      this.variants.forEach(variant => {
        variant.dataset.product == productID ? variant.classList.add("active") : variant.classList.remove("active")
      });
      this.frameValue.forEach(name => {
        name.innerText = productFrame;
      });
      sizeSection._resetButtons();
      activeProduct = tint_products_json[productID];
    }
  };

  // === Size Section ===
  let sizeSection = {
    init: function (params) {
      this.sizeImage = document.querySelector('#slider-sizes');
      this.sizeVariant = document.querySelector('#variants-sizes');
      this.buttonPrevious = document.querySelector('.lemtoshLab_sizes .button--previous');
      this.buttonNext = document.querySelector('.lemtoshLab_sizes .button--next');
      this.sizeValue = document.querySelectorAll('size-value');
      
      this._triggerButtons();
    },
    variantButtons: function () {
      if(!this.sizeVariant) return [];
      return this.sizeVariant.querySelectorAll('.variant-button');
    },
    _triggerButtons: function () {
      const buttons = this.variantButtons();
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          buttons.forEach(b => {
            b.classList.remove('active');
            b.setAttribute('aria-checked', 'false');
          });
          button.classList.add('active');
          button.setAttribute('aria-checked', 'true')
          if(this.buttonNext) {
              this.buttonNext.disabled = false;
              this.buttonNext.classList.add('animate');
          }

          this.sizeValue.forEach(name => {
            name.innerText = button.dataset.sizeValue;
          });
          tintSection._setupcolors(button.dataset.size);
        });
      });
    },
    _resetButtons: function () {
      this.variantButtons().forEach(button => {
        button.classList.remove('active');
      });
      if(this.buttonNext) this.buttonNext.disabled = true;
    }
  };

  // === Tint Section ===
  let tintSection = {
    activeSlider: null,
    activeTintImageSlider: null,
    init: function () {
      this.tintImage = document.querySelector('#slider-tint');
      this.tintVariant = document.querySelector('#variants-tints');
      this.tintValue = document.querySelectorAll('tint-value');
      this.ATCForm = document.querySelector('#bundle-add-to-cart-form');
      this.variantPiceEle = document.querySelectorAll('price');
      this.tintBackground = document.querySelector('#tint-background');

      if (!this.tintImage || !this.tintVariant) return;

      this._triggerButtons();
      const submitBtn = this.ATCForm.querySelector('.button--submit[type="submit"]');
      if (submitBtn) {
        submitBtn.addEventListener('animationend', function () {
          this.classList.remove('animate');
        });
      }

      const resizeTint = () => {
        let _media = window.matchMedia('(min-width:1000px)');
        if (_media.matches == true) {
          if (this.tintVariant && this.tintImage) {
            this.tintVariant.style.minHeight = `${this.tintImage.clientHeight}px`;
          }
        } else {
          if (this.tintVariant) {
            this.tintVariant.style.removeProperty('min-height');
          }
        }
      };

      resizeTint();
      window.removeEventListener('resize', resizeTint); // Try to avoid stacking if possible
      window.addEventListener('resize', resizeTint);
    },
    initSliders: function () {
      if (this.activeSlider) {
        this.activeSlider.destroy();
      }

      let updateClasses = (slider) => {
        slider.slides.forEach(slide => {
          slide.classList.remove('next', 'next-one', 'previous', 'previous-one')
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
          // slide.setAttribute('aria-selected', 'false');
          slide.setAttribute('aria-checked', 'false');
        });
        let length = slider.slides.length;
        let currentSlide = slider.track.details.rel;

        let next = (currentSlide + 1) >= length ? 0 : currentSlide + 1;
        let nextOne = (currentSlide + 2) >= length ? (currentSlide + 2 - length) : currentSlide + 2;
        let previous = (currentSlide - 1) < 0 ? (length - 1) : (currentSlide - 1);
        let previousOne = (currentSlide - 2) < 0 ? (length - 2 + currentSlide) : currentSlide - 2;

        let nextElement = slider.slides[next];
        let nextOneElement = slider.slides[nextOne];
        let previousElement = slider.slides[previous];
        let previousOneElement = slider.slides[previousOne];
        let currentElement = slider.slides[currentSlide];

        nextElement.classList.add('next');
        nextOneElement.classList.add('next-one');
        previousElement.classList.add('previous');
        previousOneElement.classList.add('previous-one');

        nextElement.setAttribute('aria-hidden', 'false');
        nextOneElement.setAttribute('aria-hidden', 'false');
        previousElement.setAttribute('aria-hidden', 'false');
        previousOneElement.setAttribute('aria-hidden', 'false');
        currentElement.setAttribute('aria-hidden', 'false');
        // currentElement.setAttribute('aria-selected', 'true');
        currentElement.setAttribute('aria-checked', 'true');

        nextElement.setAttribute('tabindex', '0');
        nextOneElement.setAttribute('tabindex', '0');
        previousElement.setAttribute('tabindex', '0');
        previousOneElement.setAttribute('tabindex', '0');
        currentElement.setAttribute('tabindex', '0');

        if (document.body.classList.contains('user-is-tabbing')) {
          let elements = [nextElement, nextOneElement, previousElement, previousOneElement];

          let elementToFocus = elements.reduce((minElement, currentElement) => {
            let currentSlideTo = parseInt(currentElement.getAttribute('data-slide-to'), 10);
            let minSlideTo = parseInt(minElement.getAttribute('data-slide-to'), 10);

            return currentSlideTo < minSlideTo ? currentElement : minElement;
          }, elements[0]);

          if (elementToFocus) {
            setTimeout(() => {
              elementToFocus.focus();
            }, 200)
          }
        }
      }

      if(!activeProduct || !activeProduct.product || !this.tintVariant) return;

      const mobileslider = this.tintVariant.querySelector(`.slider-variant[data-product="${activeProduct.product.id}"]`);
      // console.log(mobileslider)
      if(!mobileslider) return;

      this.activeSlider = new KeenSlider(mobileslider, {
        loop: true,
        slides: { perView: 'auto', spacing: 18, origin: 'center' },
        breakpoints: {
          "(min-width: 1000px)": {
            drag: false,
            slides: { perView: 'auto', origin: 'center', spacing: 180 },
          },
          "(min-width: 1280px)": {
            drag: false,
            slides: { perView: 'auto', origin: 'center', spacing: 220 },
          },
          "(min-width: 1440px)": {
            drag: false,
            slides: { perView: 'auto', origin: 'center', spacing: 220 },
          },
          "(min-width: 1600px)": {
            drag: false,
            slides: { perView: 'auto', origin: 'center', spacing: 200 },
          },
        },
        selector: mobileslider.querySelectorAll('.variant-button:not([disabled])'),
        created: (slider) => {
          //  console.log('created',this,slider)
          slider.slides.forEach((slide, index) => {
            slide.dataset.slideTo = index;
          });
          setTimeout(() => {
            const firstSlide = slider.slides[0];
            if(firstSlide) firstSlide.dispatchEvent(new Event('click'));
          }, 100);


          updateClasses(slider);
        },
        updated: (slider) => {
          console.log('updated');
        },
        slideChanged: (slider) => {
          // console.log('slidechanged');
          updateClasses(slider);
        }

      });

      /*
      Next/Preview Listener()
      */
      document.querySelectorAll('.js-slider-nav-button').forEach(button => {
        // Cloning to remove old event listeners
        const newBtn = button.cloneNode(true);
        button.parentNode.replaceChild(newBtn, button);
        
        newBtn.addEventListener('click', () => {
          if(!this.activeSlider) return;
          let slides = this.activeSlider.slides;
          let activeSlide = slides[this.activeSlider.track.details.rel];
          let activeSlideIndex = slides.indexOf(activeSlide);
          let nextSlide = slides[activeSlideIndex + 1] || slides[0];
          let previousSlide = slides[activeSlideIndex - 1] || slides[(slides.length - 1)];
          newBtn.classList.contains('keen-slider__next') ? nextSlide.click() : previousSlide.click();
        });
      });

    },


    _triggerButtons: function () {
      const buttons = this.tintVariant.querySelectorAll('.variant-button');
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          let tintColor = button.dataset.tintValue;
          buttons.forEach(b => b.classList.remove('active'));
          button.classList.add('active');
          this.tintValue.forEach(name => {
            name.innerText = tintColor;
          });
          const slideTo = parseInt(button.getAttribute('data-slide-to'));
          if(this.activeSlider) this.activeSlider.moveToIdx(slideTo);
          // this.activeTintImageSlider.moveToIdx(slideTo,0);
          this._selectTintImage(tintColor);
          this._setSelectedVaraint(tintColor);
        });
      });
    },
    _selectTintImage(color) {
      if(!this.tintImage) return;
      let tintSliderElement = this.tintImage.querySelector(`[data-product="${activeProduct.product.id}"]`);
      if(tintSliderElement) {
        tintSliderElement.querySelectorAll('.tint-image').forEach(image => image.classList.toggle('active', (image.dataset.tintValue == color)));
      }
    },
    _setSelectedVaraint(color) {
      if(!this.ATCForm) return;
      let selectedVariant = this.sizeVaraints.filter(variant => (variant[activeProduct.colorOptionKey] == color))[0];
      if (selectedVariant) {
        const idInput = this.ATCForm.querySelector('[name="id"]');
        if(idInput) idInput.value = selectedVariant.id;
        
        const submitBtn = this.ATCForm.querySelector('.button--submit[type="submit"]');
        if(submitBtn) submitBtn.classList.add('animate');
        
        this.variantPiceEle.forEach(element => {
          if(activeProduct.varaintPrices) element.innerHTML = activeProduct.varaintPrices[selectedVariant.id];
        });
        if(this.tintBackground && activeProduct.varaintGradients) {
           this.tintBackground.style.background = activeProduct.varaintGradients[selectedVariant.id];
        }
      }
    },
    _setupcolors: function (size) {
      if(!activeProduct || !activeProduct.product) return;
      
      this.sizeVaraints = activeProduct.product.variants.filter(variant => {
        return (variant[activeProduct.sizeOptionKey] == size && variant.available == true);
      });
      let availableColors = this.sizeVaraints.map(varaint => varaint[activeProduct.colorOptionKey])
      if(!this.tintVariant) return;
      
      let activeProductColors = this.tintVariant.querySelector(`[data-product="${activeProduct.product.id}"]`);
      if(activeProductColors) {
        activeProductColors.querySelectorAll('.variant-button').forEach(button => {
          button.disabled = !availableColors.includes(button.dataset.tintValue);
        });
      }
      
      if(!this.tintImage) return;
      let activetintImage = this.tintImage.querySelector(`[data-product="${activeProduct.product.id}"]`);
      if(activetintImage) {
        activetintImage.querySelectorAll('.tint-image').forEach(image => {
          image.classList.toggle('hidden', !availableColors.includes(image.dataset.tintValue))
        });
      }
    }
  };

  // Run initialization
  frameSection.init();
  sizeSection.init();
  tintSection.init();
};

document.addEventListener('DOMContentLoaded', () => {
  window.initLemtoshLab();
});